import type { Messengers } from '~/models/messengers';
import { messengersService } from '~/services/messengers';

export const useMessengersState = () => ({
	messengersState: useState<Messengers.Model[]>('messengersState', () => []),
	messengersLoaded: useState<boolean>('messengersLoaded', () => false),
	messengersPending: useState<boolean>('messengersPending', () => true),
});

export const useMessengers = () => {
	const { messengersState, messengersLoaded, messengersPending } = useMessengersState();

	/**
	 * Fetch messengers
	 */
	const fetchMessengers = async () => {
		if (messengersLoaded.value) return;

		messengersPending.value = true;

		messengersState.value = await messengersService.fetch();

		messengersLoaded.value = true;
		messengersPending.value = false;
	};

	return {
		messengersState,
		messengersLoaded,
		messengersPending,

		fetchMessengers,
	};
};
